import React from 'react';
import Button from '../Button';
import { FiGithub, FiDelete } from 'react-icons/fi';
import './Functions.css';

const Functions = ({ onClickDelete, onClickClear, onClickEqual }) => {
    return(
        <React.Fragment>
            <div className="btn-git" data-testid="functions">
                <Button text={<FiGithub /> ? <FiGithub size=".9em"/> : "Git"} 
                    href="https://github.com/garciapereirajuan/calculadora-javascript.git" />
            </div>
            <div className="delete" data-testid="functions">
                <Button text={<FiDelete/> ? <FiDelete/> : "Del"} id="delete" 
                onClickHandler={onClickDelete} />
            </div>
            <div className="delete-all" data-testid="functions">
                <Button text="AC" id="clear" onClickHandler={onClickClear}/>
            </div>
            <div className="equal" data-testid="functions">
                <Button text="=" id="equals" onClickHandler={onClickEqual}/>
            </div>
        </React.Fragment>
    );
}

export default Functions;